// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"350":"67f130c693fcfab48258","374":"27facecc63483232b27f","660":"66cfe5a074d37b292a46","826":"bef4b1ddd0a43e08dfea","896":"21c7e5e15b68823e7433"}[chunkId] + ".bundle.js";
};